import {
  GET_CERTAIN_CATEGORY_PAPER_NUMBER,
  GET_RECIPIENT_AND_SENDERS,
  ADD_PAPER,
  ADD_PAPER_ERROR,
  RESET_PAPER_STORE,
  CATEGORY_VALUE_0,
  GET_ALL_PAGE_PAPERS,
  GET_CERTAIN_PAGE_PAPERS,
  ALL_PAPERS_NUMBER,
  CURRENT_YEAR_PAPERS_NUMBER,
  GET_NOT_ARCHIVED_PAGE_PAPERS,
  NOT_ARCHIVED_PAPERS_NUMBER,
  GET_CERTAIN_PAPER,
	GET_CERTAIN_PAPER_ERROR,
	UPDATE_CERTAIN_PAPER,
	UPDATE_CERTAIN_PAPER_ERROR
} from "../types";

export const papersReducer = (state = [], action) => {
  switch (action.type) {
    case GET_CERTAIN_CATEGORY_PAPER_NUMBER:
      return { ...state, certainCategoryPaperNumber: action.payload };
    case GET_RECIPIENT_AND_SENDERS:
      return {
        ...state,
        recipientAndSenders: action.payload
      };
    case ADD_PAPER:
      return { ...state, addPaper: action.payload };
    case ADD_PAPER_ERROR:
      return { ...state, addPaperError: action.payload };
    case RESET_PAPER_STORE:
      return { ...state, addPaper: "" };
    case CATEGORY_VALUE_0:
      return { ...state, certainCategoryPaperNumber: [{ numPapers: 0 }] };
    case GET_ALL_PAGE_PAPERS:
      return { ...state, allPagePapers: action.payload };
    case GET_CERTAIN_PAGE_PAPERS:
      return { ...state, certainPagePapers: action.payload };
    case ALL_PAPERS_NUMBER:
      return { ...state, allPapersNumber: action.payload };
    case CURRENT_YEAR_PAPERS_NUMBER:
      return { ...state, currentYearPapersNumber: action.payload };
    case GET_NOT_ARCHIVED_PAGE_PAPERS:
      return { ...state, notArchivedPagePapers: action.payload };
    case NOT_ARCHIVED_PAPERS_NUMBER:
      return { ...state, notArchivedPapersNumber: action.payload };
    case GET_CERTAIN_PAPER:
      return { ...state, certainPaper: action.payload };
    case GET_CERTAIN_PAPER_ERROR:
      return { ...state, certainPaperError: action.payload };
    case UPDATE_CERTAIN_PAPER:
      return {
        ...state,
        status: action.payload.status,
        updatePaperMessage: action.payload.message
      };
    case UPDATE_CERTAIN_PAPER_ERROR:
      return {
        ...state,
        status: action.payload.status,
        updatePaperMessage: action.payload.message
      };
    default:
      return state;
  }
};
